/**
 * De rand waarbinnen een zwevend menu moet blijven (glasronde 0.9.186, Frank 22 okt
 * 2026): op de iPhone tekent de app tot achter de statusbalk (`viewport-fit=cover`),
 * dus "binnen het venster" is daar niet genoeg; het menu schoof over de klok heen.
 *
 * `veiligeRand` meet de veilige zone van het toestel met een meetelement, want
 * `env(safe-area-inset-*)` is alleen in CSS te lezen. Buiten een browser (jsdom) of
 * zonder veilige zone is alles 0.
 */
export function veiligeRand(doc = typeof document !== "undefined" ? document : null) {
  if (!doc || !doc.body) return { boven: 0, onder: 0 };
  const meter = doc.createElement("div");
  meter.setAttribute("data-veilige-rand-meter", "");
  meter.style.cssText = "position:fixed;visibility:hidden;pointer-events:none;"
    + "padding-top:env(safe-area-inset-top,0px);padding-bottom:env(safe-area-inset-bottom,0px);";
  doc.body.appendChild(meter);
  const stijl = doc.defaultView ? doc.defaultView.getComputedStyle(meter) : null;
  const px = (w) => { const n = parseFloat(w); return Number.isFinite(n) ? n : 0; };
  const uit = { boven: px(stijl && stijl.paddingTop), onder: px(stijl && stijl.paddingBottom) };
  meter.remove();
  return uit;
}

/** De `collisionPadding` voor Radix: een marge rondom, boven en onder plus de veilige zone. PUUR. */
export function botsingsRand({ boven = 0, onder = 0 } = {}, marge = 8) {
  return { top: marge + boven, bottom: marge + onder, left: marge, right: marge };
}
